document.addEventListener('DOMContentLoaded', function () {
  const cartContainer = document.querySelector('#cart-container') || document.body;

  cartContainer.addEventListener('change', function (event) {
    const select = event.target;
    if (select && select.classList.contains('selling-plan-select')) {
      const line = parseInt(select.dataset.line, 10);
      const quantity = parseInt(select.dataset.quantity, 10) || 1;
      const sellingPlanId = select.value;

      if (!line || !sellingPlanId) {
        console.warn('Missing required data');
        return;
      }

      const payload = {
        line: line,
        quantity: quantity,
        selling_plan: sellingPlanId,
        sections: ['cart-drawer', 'main-cart-items'],
        sections_url: window.location.pathname
      };

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.sections) {
            Object.entries(data.sections).forEach(([sectionId, html]) => {
              const container = document.getElementById(sectionId);
              if (container) {
                container.innerHTML = html;
              }
            });
          }
        })
        .catch((err) => {
          console.error('Failed to update selling plan:', err);
        });
    }
  });
});
